import { render, staticRenderFns } from "./FlexFundsOverview.vue?vue&type=template&id=1996d258&scoped=true&"
import script from "./FlexFundsOverview.vue?vue&type=script&lang=js&"
export * from "./FlexFundsOverview.vue?vue&type=script&lang=js&"
import style0 from "./FlexFundsOverview.vue?vue&type=style&index=0&id=1996d258&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1996d258",
  null
  
)

export default component.exports